module.exports = __webpack_public_path__ + "img/bonus_symbol_1.4d5da2f7.png";